import { cardLinkOut } from '@squareup/dex-ui-shared-markdown-card';
import React, { FC, PropsWithChildren } from 'react';

interface MdxCardLinkOutProps {
  href?: string;
}

const CardLinkOutComponent = cardLinkOut.component.value as FC<
  PropsWithChildren<MdxCardLinkOutProps>
>;

const MdxCardLinkOut: FC<PropsWithChildren<MdxCardLinkOutProps>> = ({
  children,
  href,
}) => {
  // Markdoc wraps {% card-link-out %} in <p> so DocCard's in-grid flex
  // rules (margin-top: auto on the link-out row) apply. MDX renders the
  // component as a direct sibling unless we mirror that wrapper.
  return (
    <p>
      <CardLinkOutComponent {...(href ? { href } : {})}>
        {children}
      </CardLinkOutComponent>
    </p>
  );
};

MdxCardLinkOut.displayName = 'MdxCardLinkOut';

export { MdxCardLinkOut };
